import React, { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import UpIcon from '@components/SvgComponents/UpIcon';
import DownIcon from '@components/SvgComponents/DownIcon';
import NurseAssignedDeviceList from './NurseAssignedDeviceList';
import { ASSIGN_PATH, HOSPITAL_USER_PATH } from '@constants/routes';
import SuperAdminTotalData from './SuperAdminTotalData';
import PreAuthorizationList from './PreAuthorizationList';
import SuperAdminChart from './SuperAdminChart';
import { FaAngleRight, FaAngleLeft } from 'react-icons/fa6';
import { HOSPITAL, INDIVIDUAL, NURSE, ADMIN } from '@constants/constants';
import { useAppDispatch, useAppSelector } from '@store/hooks';

const AnalyticsAndReportBtn = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [selectedPeriod, setSelectedPeriod] = useState('today');
    const userRole = useAppSelector((state) => state.login.loggedInUserRole);
    const handleAssigned = () => {
        navigate(ASSIGN_PATH);
    };
    const handleClickedViewAll = () => {
        navigate(HOSPITAL_USER_PATH);
    };
    const handlePeriodChange = (event: any) => {
        setSelectedPeriod(event.target.value);
    };

    return (
        <div className="2xl:max-w-full lg:max-w-[685px] xl:max-w-[940px]">
            {/* <div className=""> */}
            <SuperAdminTotalData />
            <div className="flex align-items-center justify-content-between mt-5 w-[74%] mb-4">
                <div className="d-flex align-items-center">
                    <h2 className="text-sm text-black ml-2 font-bold">
                        {t('super_admin_dashboard.app_new_user')}
                    </h2>
                </div>
                <div className="flex align-items-center xl:w-[4.2rem] lg:w-[5rem] 2xl:w-[16rem]">
                    {/* <div className="flex align-items-center"> */}
                    <select
                        className="px-3 py-2 mr-12"
                        name="type"
                        onChange={handlePeriodChange}
                        aria-label="dropdown"
                    >
                        <option value="today">
                            {t('super_admin_dashboard.today')}
                        </option>
                        <option value="this_week">
                            {t('super_admin_dashboard.this_week')}
                        </option>
                        <option value="last_week">
                            {t('super_admin_dashboard.last_week')}
                        </option>
                        <option value="this_month">
                            {t('super_admin_dashboard.this_month')}
                        </option>
                        <option value="last_month">
                            {t('super_admin_dashboard.last_month')}
                        </option>
                    </select>
                    <h2 className="text-black text-sm font-bold mr-[4rem]">
                        {t('super_admin_dashboard.customer')}
                    </h2>
                    {/* <h2 className="text-black text-sm font-bold">
                        {t('super_admin_dashboard.customer')}
                    </h2> */}
                </div>
            </div>
            <SuperAdminChart period={selectedPeriod} />
            <div>
                <div className="flex align-items-center justify-content-between mt-5">
                    <div className="flex align-items-center">
                        <h2 className="text-sm text-black font-bold">
                            {t('super_admin_dashboard.title')}
                        </h2>
                        <span className="text-gray text-xs ml-1">
                            ({t('super_admin_dashboard.sub_title')})
                        </span>
                    </div>
                    <div className="flex align-items-center">
                        <button
                            className="bg-primary flex mx-3 btn text-white py-2 pl-3 pr-8 align-items-center rounded text-white relative"
                            onClick={handleClickedViewAll}
                        >
                            {t('super_admin_dashboard.view_all')}
                            {isDropdownVisible ? (
                                <span className="absolute right-2 ml-1">
                                    <FaAngleLeft
                                        size={15}
                                        className="relative left-1.5 !text-white mr-2"
                                    />
                                </span>
                            ) : (
                                <span className="absolute right-2 ml-1 ">
                                    <FaAngleRight
                                        size={15}
                                        className="relative left-1.5 !text-white mr-2"
                                    />
                                </span>
                            )}
                        </button>
                    </div>
                </div>
                <PreAuthorizationList />
            </div>
        </div>
    );
};
export default AnalyticsAndReportBtn;
